/** EzrealPainter — 2D gauntlet silhouette. */
export const EzrealPainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.85, 0, Math.PI * 2);
    ctx.fillStyle = '#1d4ed8';
    ctx.fill();
    ctx.beginPath();
    ctx.arc(0, -radius * 0.55, radius * 0.36, 0, Math.PI * 2);
    ctx.fillStyle = '#38bdf8';
    ctx.fill();
    ctx.fillStyle = '#fbbf24';
    ctx.fillRect(radius * 0.45, -radius * 0.15, radius * 0.45, radius * 0.35);
  }
};
